import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import { cascadeProcessApi } from "./api";

import GetCascadeProcessResponse = App.Http.Responses.Cascade.GetCascadeProcessResponse;
import GetCascadeProcessExternalFinalPageSettingRequest = App.Http.Requests.Cascade.GetCascadeProcessExternalFinalPageSettingRequest;
import GetCascadeProcessExternalFinalPageSettingResponse = App.Http.Responses.Cascade.GetCascadeProcessExternalFinalPageSettingResponse;
import GetConversionApiExternalFinalPageResponse = App.Http.Responses.Conversion.GetConversionApiExternalFinalPageResponse;
import GetCascadeProcessActionRequest = App.Http.Requests.Cascade.GetCascadeProcessActionRequest;
type CascadeProcessActionRequest = GetCascadeProcessActionRequest & {
    code?: string;
};

export const useGetCascadeProcessQuery = (processId: string, tenantSlug: string, options = {}) => {
    return useQueryApi<{
        data: GetCascadeProcessResponse | GetConversionApiExternalFinalPageResponse;
        status: number;
    }>({
        queryKey: ["getCascadeProcess", tenantSlug, processId],
        queryFn: () => cascadeProcessApi.show(processId),
        ...options,
    });
};

export const useGetCascadeProcessExternalFinalPageSettingQuery = (
    processId: string,
    tenantSlug: string,
    request: GetCascadeProcessExternalFinalPageSettingRequest = {},
    options = {}
) => {
    return useQueryApi<GetCascadeProcessExternalFinalPageSettingResponse>({
        queryKey: ["getCascadeProcessExternalFinalPageSetting", tenantSlug, processId],
        queryFn: () => cascadeProcessApi.showExternalFinalPageSetting(processId, request),
        ...options,
    });
};

export const useUpdateCascadeProcessMutation = (
    options: UseMutationOptions<
        unknown,
        AxiosError<ApiErrorResponse>,
        { cascadeProcessId: string; action: string; cascadeItemId: string; request: CascadeProcessActionRequest }
    > = {}
) => {
    return useMutationApi<
        unknown,
        { cascadeProcessId: string; action: string; cascadeItemId: string; request: CascadeProcessActionRequest }
    >({
        mutationKey: ["updateCascadeProcess"],
        mutationFn: ({ cascadeProcessId, action, cascadeItemId, request }) =>
            cascadeProcessApi.update(cascadeProcessId, action, cascadeItemId, request),
        ...options,
    });
};
